<template>
    <div
        class="md product-info"
        v-if="productListInit && node.product_s"
    >
        <div
            v-if="runingAnimate"
            class="animate-node"
            :style="animateNode"
        >
            <div
                class="mask"
                :style="'background-image: url('+ node.imageurl +')'"
            ></div>
        </div>
        <div class="header">
            <div class="image-area">
                <div class="div">
                    <div
                        ref="mask"
                        class="mask"
                        :style="{
                            'background-image': 'url('+ node.imageurl +')',
                            'background-size': $siteConfig.emptyProductPhoto === node.imageurl? 'contain': 'cover',
                        }"
                    ></div>
                    <img :src="node.imageurl">
                </div>
                <div class="func">
                    <ul>
                        <li
                            class="is-favorite"
                            :class="[node.is_favorite? 'is-active': '']"
                        >
                            <a :title="$t('site.func.addfavorites')" @click.prevent.stop="favorite">
                                <span>{{ $t('site.func.addfavorites') }}</span>
                            </a>
                        </li>
                        <li class="is-contact">
                            <a :title="$t('site.func.contactsales')" @click.prevent.stop="contact">
                                <span>{{ $t('site.func.contactsales') }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="input-area">
                <div class="caption">
                    <div class="product">
                        <span class="name">{{ node.alias || node.product_s }}</span>
                        <span class="label">{{ node.product_b }}-{{ node.product_m }}</span>
                    </div>
                    <div class="price">
                        <!-- <span v-if="node.detail.pre_price && node.detail.pre_price > node.detail.price" class="prev">{{ $okaTool.numberToStringFormat(node.detail.pre_price) }}</span> -->
                        <span
                            class="main"
                            :class="[typeof price === 'number'? '': 'is-alert']"
                        >
                            <span>{{ typeof price === 'number'? 'NT$ '+ $okaTool.numberToStringFormat(price): price }}</span>
                        </span>
                        <span
                            v-if="typeof price === 'number' && AlertMessage"
                            class="extend is-alert"
                            @click="showPopUp($event, $t(AlertMessage))"
                            @mouseenter="showToolTip($event, $t(AlertMessage))"
                        ></span>
                        <cpLabel
                            v-if="listNode.discount && typeof price == 'number'"
                            themes="danger"
                            :text="$t('page.product.discount', {
                                priceType: user.ispaycash? '現金價': '票期價',
                                allowance: listNode.discount,
                                disQty: listNode.disQty || '',  
                            })"
                        ></cpLabel>
                    </div>
                </div>
                <div class="form">
                    <ul>
                        <li>
                            <div class="fieldset">
                                <label>
                                    {{ $t('site.noun.package') }}
                                    <cpLabel
                                        v-if="multipleBase"
                                        themes="danger"
                                        :text="$t('info.multiple', {num: multipleBase})"
                                    ></cpLabel>
                                </label>
                                <div class="cp input select" :class="[errors.has('package')? 'is-error': '']" :data-error="errors.first('package')" :disabled="usePackageData.length && !editable">
                                    <select v-model="result.package" v-validate="usePackageData.length && !hasNullPackage? 'required': ''" name="package" :disabled="usePackageData.length && !editable">
                                        <option v-if="!hasNullPackage" value="">{{ usePackageData.length? $t('site.noun.select') : $t('site.select.default')}}</option>
                                        <option v-for="item in usePackageData" :key="item.package_s" :value="item.package_s">{{ item.remarks }}({{ item.package_s }})</option>
                                    </select>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="fieldset">
                                <label>{{ $t('site.noun.quality') }}</label>
                                <div class="cp input select" :class="[errors.has('quality')? 'is-error': '']" :data-error="errors.first('quality')" :disabled="useQualityList.length && !editable">
                                    <select v-model="result.quality" v-validate="useQualityList.length && !hasNullQuality? 'required': ''" name="quality" :disabled="useQualityList.length && !editable">
                                        <option v-if="!hasNullQuality" value="">{{ useQualityList.length? $t('site.noun.select') : $t('site.select.default')}}</option>
                                        <option v-for="item in useQualityList" :key="item.quality" :value="item.quality">{{ item.remarks }}</option>
                                    </select>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="fieldset">
                                <label>
                                    {{ $t('site.noun.deliverydate') }}
                                </label>
                                <div @mouseenter="contactRemark ? showToolTip($event, contactRemark) : ''">
                                    <cpDatePicker
                                        type="date"
                                        :errorStatus="errors.has('customer_need_date')"
                                        :errorMsg="errors.first('customer_need_date')"
                                        v-model="result.customer_need_date"
                                        v-validate="'required'"
                                        :hideLabel="true"
                                        :disabled="!editable"
                                        :dayRestriction="$siteTool.dayRestriction"
                                        name="customer_need_date"
                                        ref="customer_need_date"
                                        @input="init"
                                        
                                    ></cpDatePicker>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="fieldset">
                                <label>
                                    {{ $t('site.noun.qty') }}
                                    <cpLabel
                                        themes="danger"
                                        text="KG"
                                    ></cpLabel>
                                </label>
                                <div class="cp input text" :class="[errors.has('qty')? 'is-error': '']" :data-error="errors.first('qty')" :disabled="!editable">
                                    <input type="text" min="0.01" step="1" v-model="result.qty" v-validate="multipleBase? '|multiple_of:'+ multipleBase: ''+ 'required|min_value: 0.01|decimal:2'" name="qty" :disabled="!editable">
                                </div>
                            </div>
                        </li>
                        <li class="is-double">
                            <div class="fieldset">
                                <label>
                                    {{ $t('site.noun.dispatch') }}
                                </label>
                                <div class="cp input select" :class="[errors.has('outmfct')? 'is-error': '']" :data-error="errors.first('outmfct')" :disabled="!editable">
                                    <select v-model="result.outmfct" v-validate="''" name="outmfct" :disabled="!editable">
                                        <option value="">{{ $t('site.select.defaultForOutmfct')}}</option>
                                        <option v-for="item in useOutmfctData" :key="item.eqdp" :value="item.eqdp">{{ langID === 'zh'? item.orgunitname: item.outmpz }}</option>
                                    </select>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="fieldset">
                    <ul>
                        <li>
                            <cpBtn
                                themes="forth"
                                icon="shopping_bag"
                                :text="$t('page.myorders.func.ordernow')"
                                extendClass="is-block is-large"
                                :disabled="!editable"
                                @click.prevent="addToCart(true)"
                            ></cpBtn>
                        </li>
                        <li>
                            <cpBtn
                                themes="success"
                                icon="add_shopping_cart"
                                :text="$t('site.func.addtocart')"
                                extendClass="is-block is-large is-hover"
                                :disabled="!editable"
                                @click.prevent="addToCart(false)"
                            ></cpBtn>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="content">
            <div
                v-if="node.description"
                class="text-area"
            >
                <div class="introduce-caption">{{ $t('page.product.title.detail') }}</div>
                <div class="text" v-html="typeof node.description === 'string'? node.description.replace(/\r\n/g,'<br>'): node.description"></div>
            </div>
            <div
                v-if="fileList.length"
                class="file-area"
            >
                <div class="introduce-caption">{{ $t('page.product.title.download') }}</div>
                <cpMajorTab
                    :tabs="tabs"
                    :active="fileType"

                    @sendEvent="receiveEvent"
                ></cpMajorTab>
                <!-- <div class="fieldset">
                    <div class="cp input select">
                        <select v-model="fileType">
                            <option
                                v-for="(item, key) in fileTypeList"
                                :key="key"
                                :value="key"
                            >{{ item[langID] }}</option>
                        </select>
                    </div>
                </div> -->
                <ul>
                    <li
                        v-for="file in fileList"
                        :key="file.sn"
                    >
                        <cpFile
                            v-if="langID === 'zh'"
                            :type="getFileExtension(file.file_zh)"
                            :name="file.document_zh"
                            :extend="false"
                            @clickFile="getFile(file.file_zh)"
                        ></cpFile>
                        <cpFile
                            v-else
                            :type="getFileExtension(file.file_en)"
                            :name="file.document_en"
                            :extend="false"
                            @clickFile="getFile(file.file_en)"
                        ></cpFile>
                    </li>
                </ul>
            </div>
            <div
                v-if="node.info_urls"
                class="image-area"
            >
                <div
                    class="image"
                    v-for="item in node.info_urls"
                    :key="item"
                >
                    <img :src="item">
                </div>
            </div>
        </div>
    </div>
    <div
        v-else
        class="g mask-box-side"
    >
        <transition name="fade">
            <mdLoading></mdLoading>
        </transition>
    </div>
</template>

<script>
    import cpDatePicker from '@/components/cpDatePicker'
    import cpBtn from '@/components/cpBtn'
    import cpFile from '@/components/cpFile'
    import cpLabel from '@/components/cpLabel'
    import cpMajorTab from '@/components/cpMajorTab'
    import mdLoading from '@/components/cpLabel'
    import VueCookie from 'vue-cookie'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            cpDatePicker,
            cpBtn,
            cpFile,
            cpLabel,
            cpMajorTab,
            mdLoading,
        },
        props: {
            sn: {
                type: String,
                require: true,
            },
        },
        data: function(){

            return {
                node: {
                    detail: {},
                    description: '',
                },
                result: {
                    package: '',
                    quality: '',
                    customer_need_date: '',
                    qty: null,
                    outmfct: '',
                },
                runingAnimate: false,
                animateNode: {},
                alertData: [
                    {
                        product_b: 'NAOH',
                        product_m: 'NA-F1',
                        product_s: 'NA-F1',
                        message: 'product.info.alert',
                    },
                    {
                        product_b: 'NAOH',
                        product_m: 'NA-P',
                        product_s: 'NA-P',
                        message: 'product.info.alert',
                    },
                ],
                fileType: '',
                contactRemark: '',//聯絡備註
            }
        },
        computed: {
            ...mapState([
                'user',
                'packageData',
                'packageMultipleData',
                'qualityList',
                'dispatchList',
                'selectedDateList',
                'productListInit',
                'selectedDateListInit',
                'productList',
                'langID',
            ]),
            tabs: function(){
                let $fileTypeList = this.fileTypeList,
                    _langID = this.langID,
                    $result = {}

                for( let _key in $fileTypeList ) {

                    $result[_key] = {
                        caption: $fileTypeList[_key][_langID],
                    }
                }

                return $result;
            },
            listNode: function(){
                let $productList = this.productList,
                    $node = this.node,
                    $target = $productList.find(item => item.product_sn === $node.product_sn);

                return $target || {}
            },
            fileList: function(){
                let $listNode = this.listNode,
                    $files = $listNode.files || []

                let _fileType = this.fileType;

                return $files.filter(item => item.report_en === _fileType);
            },
            multipleBase: function(){
                let _product_s = this.node.product_s,
                    _package = this.result.package;

                let _result = null;

                if( _product_s && _package ) {
                    let $target = this.packageMultipleData.find(item => item.product_s === _product_s && item.package_s === _package);

                    if( $target ) {
                        _result = $target.target_amount_multiple || 1;
                    }
                }

                return _result;
            },
            price: function(){
                let $node = this.node,
                    $result = this.result,
                    $date = new Date();

                if( $result.customer_need_date ) {
                    $date = new Date($result.customer_need_date);
                }

                let _date = $date.toLocaleDateString(),
                    _result = this.$siteTool.computedPrice({
                        product_b: $node.product_b,
                        product_m: $node.product_m,
                        product_s: $node.product_s,
                        package_s: $result.package,
                        quality: $result.quality,
                        dsr_codiv: $node.product_codiv,
                    }, _date);

                return _result;
            },
            editable: function(){
                return this.node.available && this.user.sn;
            },
            usePackageData: function() {
                let $result = this.$siteTool.getPackage(this.node);

                return $result.sort((a, b) => a.package_s > b.package_s ? 1 : -1);
            },
            useOutmfctData: function() {
                return this.$siteTool.getOutmfct(this.node);
            },
            useQualityList: function() {
                return this.$siteTool.getQuality(this.node);
            },
            hasNullPackage: function(){
                return !!this.usePackageData.find(item => item.package_s === '');
            },
            hasNullQuality: function(){
                return !!this.useQualityList.find(item => item.quality === '');
            },
            AlertMessage: function(){
                let $alertData = this.alertData,
                    $node = this.node,
                    _product_b = $node.product_b,
                    _product_m = $node.product_m,
                    _product_s = $node.product_s;

                let $target = $alertData.find(item => {
                        let __product_b = item.product_b || _product_b, //如果沒設定，中類或小類，就當作 match
                            __product_m = item.product_m || _product_m,
                            __product_s = item.product_s || _product_s;

                        return __product_b === _product_b && __product_m === _product_m && __product_s === _product_s;
                    });

                if( $target ) {
                    return $target.message;
                }else {
                    return 'product.info.alert2';
                }
            },
            fileTypeList: function(){
                let $listNode = this.listNode,
                    $files = $listNode.files || []

                let $result = {}

                $files.forEach(item => {
                    let _report_en = item.report_en;
                    
                    if( !$result[_report_en] ) {

                        $result[_report_en] = {
                            en: _report_en,
                            zh: item.report,
                        }
                    }
                });

                return $result;
            },
        },
        watch: {
            listNode: {
                handler: function(){
                    this.getFileList();
                }
            },
            'node.product_s': {
                handler: function(){
                    this.getContactRemark();
                }
            }
        },
        methods: {
            ...mapMutations([
                'catchError',
                'pushNotification',
                'changeShoppingCart',
                'pushToolTip',
                'pushPopUp',
                'setFavorite',
                'setPriceObject',
                'initHolidayList',
                'updateProductFile'
            ]),
            changeTab: function(opt){
                this.$set(this, 'fileType', opt);
            },
            getFileExtension: function(fileName){
                return (/[.]/.exec(fileName)) ? /[^.]+$/.exec(fileName)[0] : undefined;
            },
            getFile: function(url){
                window.open(url)
            },
            getFileList: function(){
                let $listNode = this.listNode;
                
                //修正若listNode沒有資料的時候$listNode.files.length出現異常的問題
                if( $listNode.files && $listNode.files.length ) {
                    this.$set(this, 'fileType', $listNode.files[0].report_en);
                }else {
                    let _url = this.$siteTool.apiUrl({
                            class: 'document',
                        }),
                        $condition = {
                            product_s: $listNode.product_s,
                        }

                    this.$http.post(_url, $condition).then(res => { //弄完所有設定後開始取資料
                        let $files = res || []

                        if( $files.length ) {

                            this.updateProductFile({
                                target: $listNode,
                                files: $files,
                            });

                            this.$set(this, 'fileType', $files[0].report_en);
                        }

                    }).catch(error => {

                        this.catchError({
                            error: error,
                            callback: this.getFileList,
                        });
                    });
                }
            },
            showPopUp: function(evt, str){
                
                this.pushPopUp({
                    type: 'alert',
                    content: {
                        html: str
                    },
                })
            },
            showToolTip: function(evt, str){
                
                this.pushToolTip({
                    type: 'toolTip',
                    event: evt,
                    content: {
                        html: str
                    },
                    pointerEvents: 'none'
                })
            },
            addToCart: async function(orderNow){

                if( !this.runingAnimate ) {

                    this.$validator.validate().then(async result => {

                        if (!result){
                            //啊就沒通過啊
                        }else {

                            try {
                                let $response = await this.sendAdd();

                                let $price = this.price,
                                    $package = this.packageData.find(item =>{
                                        return item.codiv === $response.dsr_codiv && item.package_s === $response.package_s && item.product_s === $response.product_s 
                                    }),
                                    $used = this.qualityList.find(item =>{
                                        return item.codiv === $response.dsr_codiv && item.quality === $response.quality && item.product_s === $response.product_s 
                                    });
                                    
                                let $inprice = 0;

                                if($package ){
                                    $inprice += $package.inprice;
                                }

                                if($used){
                                    $inprice += $used.inprice;
                                }

                                if(typeof  $price === 'number'){
                                    $response.price = $price - $inprice;
                                }else{
                                    $response.price = $price;
                                }

                                $response.contactRemark = this.contactRemark;

                                this.changeShoppingCart({
                                    func: 'add',
                                    data: $response,
                                });

                                if( orderNow ) {
                                    VueCookie.set('orderSn', $response.cart_sn, 3);

                                    console.log('orderSn', $response.cart_sn)

                                    this.$router.push('/system/cartList');
                                    
                                }else {
                                    this.addAnimate();
                                }
                                
                            }catch(error) {

                                this.catchError({
                                    error: error,
                                    callback: () => {
                                        this.addToCart(orderNow);
                                    },
                                });
                            }
                        }
                    });
                }
            },
            addAnimate: function(){
                let _int = 100, //分幾格
                    _speed = 500, //動畫持續多久
                    _log = 0,
                    _base = _speed / _int, //毫秒數
                    $timer = null;

                let $mask = this.$refs.mask, //照片
                    _maskHeight = $mask.offsetHeight,
                    _maskWidth = $mask.offsetWidth,
                    $maskRect = $mask.getBoundingClientRect(),
                    _maskTop = $maskRect.top,
                    _maskLeft = $maskRect.left,
                    _maskOpacity = 1;

                let $target = document.querySelector('.md.site-tools .shopping'), //購物車 icon,
                    _targetHeight = $target.offsetHeight,
                    _targetWidth = $target.offsetWidth,
                    $targetRect = $target.getBoundingClientRect(),
                    _targetTop = $targetRect.top,
                    _targetLeft = $targetRect.left,
                    _targetOpacity = 0;

                let _intTop = (_maskTop - _targetTop) / _int, //差別
                    _intLeft = (_maskLeft - _targetLeft) / _int,
                    _intWidth = (_maskWidth - _targetWidth) / _int,
                    _intHeight = (_maskHeight - _targetHeight) / _int,
                    _intOpacity = (_maskOpacity - _targetOpacity) / _int;

                this.$set(this, 'animateNode',  {
                    top: _maskTop +'px',
                    left: _maskLeft +'px',
                    width:  _maskWidth +'px',
                    height: _maskHeight +'px',
                    opacity: _maskOpacity,
                });

                this.$set(this, 'runingAnimate', true);

                clearInterval($timer);

                $timer = setInterval(() => {
                    _log += 1;

                    _maskTop -= _intTop;
                    _maskLeft -= _intLeft;
                    _maskWidth -= _intWidth;
                    _maskHeight -= _intHeight;
                    _maskOpacity -= _intOpacity;

                    this.$set(this, 'animateNode',  {
                        top: _maskTop +'px',
                        left: _maskLeft +'px',
                        width:  _maskWidth +'px',
                        height: _maskHeight +'px',
                        opacity: _maskOpacity,
                    });

                    if(_log >= _int){
                        clearInterval($timer);
                        this.$set(this, 'runingAnimate', false);
                    }
                }, _base);
            },
            sendAdd: function(){
                let $result = this.result,
                    _package = $result.package,
                    _quality = $result.quality,
                    _customer_need_date = $result.customer_need_date,
                    _outmfct = $result.outmfct,
                    _qty = $result.qty;

                _qty = parseFloat(_qty);
                _customer_need_date = Date.parse(_customer_need_date.replaceAll('-', '/')) / 1000;
                
                let $node = this.node,
                    _product_sn = $node.product_sn;

                let _url = this.$siteTool.apiUrl({
                        class: 'ShoppingCart',
                        func: 'Add',
                    }),
                    $condition = {
                        product_sn: _product_sn,
                        package: _package,
                        quality: _quality,
                        customer_need_date: _customer_need_date,
                        outmfct: _outmfct,
                        qty: _qty,
                    }

                return this.$http.post(_url, $condition);
            },
            favorite: function(){
                let $node = this.node,
                    _sn = $node.product_sn,
                    _favorite = !$node.is_favorite;

                this.setFavorite({
                    sn: _sn,
                    favorite: _favorite,
                    callback: () => {
                        $node.is_favorite = _favorite;
                    }
                })
            },
            contact: function(){
                this.$emit('sendEvent', 'contact', this.node.product_sn);
            },
            getContactRemark: async function(){
                //http://10.153.196.208:8081/salenet_api/ContactRemark/zh/4751
                let _node = this.node,
                    _product_s = _node.product_s;
                    console.log(_product_s,this.node)
                try {

                    let _url = this.$siteTool.apiUrl({
                                class: 'ContactRemark',
                            }),
                        $condition = {
                                product_s: _product_s,
                            }
                        
                    let $data = await this.$http.post(_url, $condition),
                        $contactRemark = $data.contact_remark || '';

                    this.$set(this, 'contactRemark', $contactRemark);
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.init,
                    });
                }
            },
            initProductInfo: function(data){

                if( !data.imageurl ) {
                    data.imageurl = this.$siteConfig.emptyProductPhoto;
                }

                this.$set(this, 'node', data);

                let $usePackageData = this.usePackageData,
                    $useQualityList = this.useQualityList;

                if( $usePackageData.length === 1 ) {
                    this.$set(this.result, 'package', $usePackageData[0].package_s);
                }

                if( $useQualityList.length === 1 ) {
                    this.$set(this.result, 'quality', $useQualityList[0].quality);
                }
            },
            init: async function(){
                let _sn = this.sn,
                    _date = new Date().toLocaleDateString();

                if(this.result.customer_need_date) {
                    _date = new Date(this.result.customer_need_date).toLocaleDateString();
                }

                try {
                    let $info = await this.$siteTool.getProductInfo({
                            sn: _sn,
                            date: _date,
                        }),
                        $detail = $info.detail || {},
                        _price = $detail.price || null;

                    this.setPriceObject({
                        sn: _sn,
                        date: _date,
                        price: _price,
                    });

                    this.initProductInfo($info);
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.init,
                    });
                }
            },
        },
        created: function(){
            this.init();

            let _date = new Date().toLocaleDateString();

            if( _date !== this.selectedDateListInit ) {
                this.initHolidayList();
            }
        },
    }
</script>

<style scoped lang="scss">

    .md.product-info {

        .animate-node {
            position: fixed;
            z-index: 13;

            .mask {
                position: absolute;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                background-color: $minor-color;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
            }
        }

        .header {
            display: flex;

            @include rwd(1024) {
                flex-direction: column;
            }

            .image-area {
                position: relative;
                width: 100%;

                @include rwd(1024) {
                    width: auto;
                    padding-bottom: 50%;
                }

                @include media('phone') {
                    width: auto;
                    padding-bottom: 80%;
                }

                .div {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    overflow: hidden;

                    .mask {
                        position: absolute;
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: cover;
                        background-color: $minor-color;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                        transition: $transition;
                        border-radius: $border-radius;
                    }

                    img {
                        display: none;
                    }
                }

                .func {
                    position: absolute;
                    left: $interval-m;
                    bottom: $interval-m;

                    ul {
                        @extend %reset;
                        white-space: nowrap;
                    }

                    li {
                        display: inline-block;

                        + li {
                            margin-left: $interval-s;
                        }

                        &.is-favorite {

                            &.is-active {
                                $type: map-get($colors, 'danger');
                                $text: map-get($type, 'text');

                                a {

                                    &:before {
                                        content: '\e87d';
                                        color: $text;
                                    }
                                }
                            }

                            a {

                                &:before {
                                    content: '\e87e';
                                }
                            }
                        }

                        &.is-contact {

                            a {

                                &:before {
                                    content: '\e0cb';
                                }
                            }
                        }
                    }

                    a {
                        display: block;
                        padding: $interval-xs $interval-m;
                        text-align: center;
                        cursor: pointer;
                        content: $content;
                        transition: $transition;
                        border-radius: $border-radius;
                        white-space: nowrap;
                        background-color: rgba-set($white, $opacity-vh);
                        color: $major-color;
                        // border: $border;
                        // border-color: $major-color;

                        &:hover {
                            background-color: $major-color;
                            color: $white;
                        }

                        &:before {
                            @extend %font-pseudo;
                            font-size: $font-size-xl;
                            margin-right: $interval-s;
                            vertical-align: middle;
                        }

                        span {
                            vertical-align: middle;
                        }
                    }
                }
            }

            .input-area {
                padding-left: $interval-m;

                @include rwd(1024) {
                    padding-left: 0;
                }

                .caption {
                    padding: $interval-m;
                    
                    .product {

                        .name {
                            margin-right: $interval-m;
                            font-size: $font-size-xxxl;
                            font-weight: bold;
                        }
                        
                        .label {
                            font-size: $font-size-xxl;
                            color: $major-color;
                            border-radius: $border-radius;
                        }
                    }
                        
                    .price {
                        // border-bottom: $border;
                        // border-bottom-color: $gray;
                        // border-bottom-style: dotted;

                        .prev {
                            text-decoration: line-through;
                            margin-right: $interval-m;
                            font-size: $font-size-xl;
                        }

                        %formater {
                            $type: map-get($colors, 'danger');
                            $text: map-get($type, 'text');

                            color: $text;

                            &.is-alert {

                                &::before {
                                    $type: map-get($colors, 'danger');
                                    $text: map-get($type, 'text');

                                    @extend %font-pseudo;
                                    vertical-align: middle;
                                    margin-right: $interval-s;
                                    position: relative;
                                    margin-right: $interval-xs;
                                    color: $text;
                                }
                            }
                        }

                        .main {
                            @extend %formater;
                            font-size: $font-size-xxxxl;

                            span {
                                vertical-align: middle;
                            }

                            &.is-alert {

                                &::before {
                                    content: '\e001';
                                }
                            }
                        }
                    }
                }

                .form {

                    ul {
                        display: flow-root;
                        @extend %reset;
                    }

                    li {
                        float: left;
                        width: 50%;

                        &.is-double {
                            width: 100%;
                        }
                    }
                }

                .fieldset {
                    padding: $interval-m;

                    %formater {
                        $type: map-get($colors, 'danger');
                        $text: map-get($type, 'text');

                        color: $text;

                        &.is-alert {

                            &::before {
                                $type: map-get($colors, 'danger');
                                $text: map-get($type, 'text');

                                @extend %font-pseudo;
                                vertical-align: middle;
                                margin-right: $interval-s;
                                position: relative;
                                margin-right: $interval-xs;
                                color: $text;
                            }
                        }
                    }

                    label {
                        display: block;
                        margin-bottom: $interval-xs;

                        .extend {
                            @extend %formater;
                            font-size: $font-size-xxl;

                            &.is-alert {

                                &::before {
                                    content: '\e001';
                                }
                            }
                        }
                    }

                    .cp.input {
                        width: 100%;
                    }

                    > ul {
                        @extend %reset;
                        display: flex;

                        li {

                            + li {
                                flex: 1;
                                padding-left: $interval-m;
                            }
                        }
                    }
                }

                > .fieldset {
                    padding-bottom: 0;
                }
            }
        }

        .content {
            padding-top: $interval-l;
            // border-top: $border;
            // border-top-color: $major-color;
            // margin-top: $interval-l;

            .introduce-caption {
                background-color: $light;
                padding: $interval-xs $interval-m;
                font-size: $font-size-xl;
            }
        }

        .text-area {
            background-color: $white;
            padding: $interval-xl;
            border-radius: $border-radius;

            + .file-area {
                margin-top: $interval-l;
            }

            + .image-area {
                margin-top: $interval-l;
            }
            .introduce-caption {
                margin-bottom: $interval-l;
            }

            .text {
                font-size: $font-size-l;
            }
        }

        .file-area {
            background-color: $white;
            padding: $interval-xl;
            border-radius: $border-radius;

            + .image-area {
                margin-top: $interval-l;
            }
            .introduce-caption {
                margin-bottom: $interval-m;
            }

            .fieldset {
                margin-bottom: $interval-m;
            }

            ul {
                @extend %reset;
                margin-top: $interval-l;
            }

            li {
                display: inline-block;
            }
        }

        .image-area {

            .image {

                + .image {
                    margin-top: $interval-m;
                }
            }

            img {
                display: block;
                width: 100%;     
                border-radius: $border-radius;
            }
        }
    }

    .g.mask-box-side {

        &::v-deep {

            .md.loading {
                height: calc(100vh - 140px);
            }
        }
    }
</style>
